export const TOOL_TYPE_RELEASED = "released";
